import { PlayerCardsContextData } from "./PlayerCardsContext";
import { UserContextData } from "./UserContext";
import { ContentPage, PlayerCardWidget } from "@/services/bedrock";
import { createInitialRecordContextData, createRecordContextData, RecordContextData } from "./RecordContext";
import { useContentPageSearch } from "@/utils/useContentPageSearch";
import { useCallback } from "react";

export interface ContentPageContextData extends RecordContextData<ContentPage> {}

export const InitialContentPageContextData: ContentPageContextData = createInitialRecordContextData<ContentPage>();

export const ContentPageContext = (
  PlayerCards: PlayerCardsContextData,
  User: UserContextData
): ContentPageContextData => {
  const { fetchContentPages } = useContentPageSearch();
  const fetchPage = useCallback(
    (playerId: number, page: number, perPage: number, search?: string) => {
      return fetchContentPages({
        playerId,
        search,
        page,
        perPage,
        sort: "created_date",
        order: "desc",
      });
    },
    [fetchContentPages]
  );
  const getRecordFromWidget = (w: PlayerCardWidget): ContentPage | null => {
    return w.owner?.type === "ContentPage" ? w.owner.contentPage ?? null : null;
  };
  const isRecordNewer = (record: ContentPage, otherRecord?: ContentPage) => {
    if (!otherRecord) return true;
    return record.createdDate > otherRecord.createdDate;
  };

  return createRecordContextData<ContentPage>(
    PlayerCards,
    User,
    "Video Page",
    fetchPage,
    getRecordFromWidget,
    isRecordNewer
  );
};
